import { useCallback } from 'react';

import { useStores } from 'mobx/hooks/useStores';

import { TicketResolutionResponse } from 'fetchers/TicketsFetcher';

import Ticket from 'models/Ticket';

import { useTicketResolve } from 'hooks/useTicketResolve';

interface UseTicketResolveReturn {
  (tickets: Ticket[], comment?: string, patientId?: number): Promise<
    TicketResolutionResponse | undefined
  >;
}

export const useBulkTicketResolve = (): UseTicketResolveReturn => {
  const { ticketsStore } = useStores();
  const ticketResolve = useTicketResolve();

  return useCallback(
    function bulkResolveTickets(tickets: Ticket[], comment?: string, patientId?: number) {
      ticketsStore.resetTicketsBulkActionSet();
      return ticketResolve({ tickets, comment, patientId });
    },
    [ticketResolve, ticketsStore]
  );
};
